<template>
    <section class="single-area responsive-content area-padding mid-top-padding">
      <div class="service-fluid">
        <div class="container">
          <div class="">
            <h3 class="">
               Estados <span class="primary">Financieros</span>.
            </h3>
            <!-- 2024 -->
            <div id="2025">
              <div class="display-flex">
                <h4>2025</h4>
                <div class="vs-divider mt-4"></div>
              </div>
              <p>
                <strong>
                  1er Trimestre 2025 - <a class="router-link-customize" :href="getURL('2025-1')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong>
              </p>
            </div>
            <!-- 2024 -->
            <div id="2024">
              <div class="display-flex">
                <h4>2024</h4>
                <div class="vs-divider mt-4"></div>
              </div>
              <p>
                <strong>
                  4to Trimestre 2024 Dictaminados - <a class="router-link-customize" :href="getURL('2024')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong><br>
                <strong>
                  3er Trimestre 2024 - <a class="router-link-customize" :href="getURL('2024-3-fc')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong><br>
                <strong>
                  2do Trimestre 2024 - <a class="router-link-customize" :href="getURL('2024-2-fc')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong><br>
                <!-- <strong>
                  1er Trimestre 2024 - <a class="router-link-customize" :href="getURL('2024-1')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong><br> -->
                <strong>
                  1er Trimestre 2024 - <a class="router-link-customize" :href="getURL('2024-1-fc')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong>
              </p>
            </div>
            <!-- 2023 -->
            <div id="2023">
              <div class="display-flex">
                <h4>2023</h4>
                <div class="vs-divider mt-4"></div>
              </div>
              <p>
                <!-- <strong>
                  Anuales Dictaminados 2023 - <a class="router-link-customize" :href="getURL('2023')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong><br> -->
                <strong>
                  4to Trimestre 2023 Dictaminados - <a class="router-link-customize" :href="getURL('2023-fc')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong><br>
                <!-- <strong>
                  3er Trimestre 2023 - <a class="router-link-customize" :href="getURL('2023-3')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong><br> -->
                <strong>
                  3er Trimestre - <a class="router-link-customize" :href="getURL('2023-3-fc')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong><br>
                <!-- <strong>
                  2do Trimestre 2023 - <a class="router-link-customize" :href="getURL('2023-2')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong><br> -->
                <strong>
                  2do Trimestre - <a class="router-link-customize" :href="getURL('2023-2-fc')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong><br>
                <!-- <strong>
                  1er Trimestre 2023 - <a class="router-link-customize" :href="getURL('2023-1')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong><br> -->
                <strong>
                  1er Trimestre - <a class="router-link-customize" :href="getURL('2023-1-fc')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong>
              </p>
            </div>
            <!-- 2023 -->
            <!-- 2022 -->
            <div id="2022">
              <div class="display-flex">
                <h4>2022</h4>
                <div class="vs-divider mt-4"></div>
              </div>
              <p>
                <!-- <strong>
                  Anuales Dictaminados 2022 - <a class="router-link-customize" :href="getURL('2022')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong><br> -->
                <strong>
                  4to Trimestre 2022 Dictaminados - <a class="router-link-customize" :href="getURL('2022-fc')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong><br>
                <!-- <strong>
                  3er Trimestre 2022 - <a class="router-link-customize" :href="getURL('2022-3')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong><br> -->
                <strong>
                  3er Trimestre - <a class="router-link-customize" :href="getURL('2022-3-fc')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong><br>
                <!-- <strong>
                  2do Trimestre 2022 - <a class="router-link-customize" :href="getURL('2022-2')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong><br> -->
                <strong>
                  2do Trimestre - <a class="router-link-customize" :href="getURL('2022-2-fc')" target="_blank" download rel="noopener">&nbsp;&nbsp;&nbsp;&nbsp;<em class='fa fa-file-pdf' style='color: red'></em>&nbsp;&nbsp;Descargar</a>
                </strong>
              </p>
            </div>
            <!-- 2022 -->
          </div>
          <!-- <embed :src="pdfURL" type="application/pdf" width="100%" height="650px" /> -->
        </div><!-- container -->
      </div><!-- end service-fluid -->
    </section>
</template>

<script>
export default {
  name: "FPEmbebed",
  data() {
    return {
      pdfURL: ""
    }
  },
  methods: {
    getURL (quarter) {
      const pdfNames = {
        "2022-2" : "Estados-Financieros-2do-Trimestre-2022.pdf",
        "2022-2-fc" : "Estados-Financieros-2do-Trimestre-2022-Firma-Censurada.pdf",
        "2022-3" : "Estados-Financieros-3er-Trimestre-2022.pdf",
        "2022-3-fc" : "Estados-Financieros-3er-Trimestre-2022-Firma-Censurada.pdf",
        "2022" : "Estados-Financieros-Anuales-Dictaminados-2022.pdf",
        "2022-fc" : "Estados-Financieros-Anuales-Dictaminados-2022-Firma-Censurada.pdf",

        "2023-1" : "Estados-Financieros-1er-Trimestre-2023.pdf",
        "2023-1-fc" : "Estados-Financieros-1er-Trimestre-2023-Firma-Censurada.pdf",
        "2023-2" : "Estados-Financieros-2do-Trimestre-2023.pdf",
        "2023-2-fc" : "Estados-Financieros-2do-Trimestre-2023-Firma-Censurada.pdf",
        "2023-3" : "Estados-Financieros-3er-Trimestre-2023.pdf",
        "2023-3-fc" : "Estados-Financieros-3er-Trimestre-2023-Firma-Censurada.pdf",
        "2023" : "Estados-Financieros-Anuales-Dictaminados-2023.pdf",
        "2023-fc" : "Estados-Financieros-Anuales-Dictaminados-2023-Firma-Censurada.pdf",
        
        "2024-1" : "Estados-Financieros-1er-Trimestre-2024.pdf",
        "2024-1-fc" : "Estados-Financieros-1er-Trimestre-2024-Firma-Censurada.pdf",
        "2024-2-fc" : "Estados-Financieros-2do-Trimestre-2024-Firma-Censurada.pdf",
        "2024-3-fc" : "Estados-Financieros-3er-Trimestre-2024-Firma-Censurada.pdf",
        "2024" : "Estados-Financieros-Anuales-Dictaminados-2024.pdf",

        "2025-1" : "Estados-Financieros-1er-Trimestre-2025.pdf",
      };

      return `https://cdn.redgirasol.com/informativos/Estados-Financieros/${pdfNames[quarter] || ""}`;
    }
  }
}
</script>

<style scoped>

</style>